/* eslint-disable jsx-a11y/click-events-have-key-events */
import { connect } from 'react-redux';
import { isFunction, noop } from 'lodash/fp';
import { variants } from '@ahmdigital/ui';
import classNames from 'classnames';
import React, { Component } from 'react';

import { MODAL_ID } from './constants';
import Animate from '../animate';
import browserUtil from '../../utils/browser';
import ModalActions from '../../actions/modal';
import styles from './styles.module.sass';

// @ts-expect-error - Automatic, Please fix when editing this file
const stopEventPropagation = (event) => {
  event.stopPropagation();
};

type ModalProps = {
  afterClose?: (...args: unknown[]) => unknown;
  afterOpen?: (...args: unknown[]) => unknown;
  beforeClose?: (...args: unknown[]) => unknown;
  beforeOpen?: (...args: unknown[]) => unknown;
  bodyElementId?: string;
  children?: React.ReactNode;
  dispatch: (...args: unknown[]) => unknown;
  displayCloseCross?: boolean;
  footer?: React.ReactNode;
  header?: React.ReactNode;
  id: string;
  theme?: string;
  variant?: unknown;
  visible: boolean;
};

class Modal extends Component<ModalProps> {
  /* eslint-disable-next-line react/sort-comp */
  // @ts-expect-error - Automatic, Please fix when editing this file
  UNSAFE_componentWillUpdate(nextProps) {
    const { body } = browserUtil.getDocument();
    let offset;
    const { beforeClose, beforeOpen, visible } = this.props;

    // Modal is opening
    if (!visible && nextProps.visible) {
      if (isFunction(beforeOpen)) {
        beforeOpen();
      }
      // @ts-expect-error - Automatic, Please fix when editing this file
      offset = body.scrollTop;
      // @ts-expect-error - Automatic, Please fix when editing this file
      body.style.top = `${offset * -1}px`;
      // @ts-expect-error - Automatic, Please fix when editing this file
      body.classList.add(styles.disableBody);
    }

    // Modal is closing
    if (visible && !nextProps.visible) {
      if (isFunction(beforeClose)) {
        beforeClose();
      }

      // Wait for animation to complete before removing
      setTimeout(() => {
        // @ts-expect-error - Automatic, Please fix when editing this file
        offset = parseInt(body.style.top, 10);
        // @ts-expect-error - Automatic, Please fix when editing this file
        body.classList.remove(styles.disableBody);
        // @ts-expect-error - Automatic, Please fix when editing this file
        body.scrollTop = offset * -1;
      }, 700);
    }
  }

  // @ts-expect-error - Automatic, Please fix when editing this file
  componentDidUpdate(prevProps) {
    const { afterClose, afterOpen, visible } = this.props;

    if (!prevProps.visible && visible) {
      if (isFunction(afterOpen)) {
        afterOpen();
      }

      this.addKeyEventListener();
    }

    if (prevProps.visible && !visible) {
      this.removeKeyEventListener();
      if (isFunction(afterClose)) {
        afterClose();
      }
    }
  }

  // @ts-expect-error - Automatic, Please fix when editing this file
  componentWillUnmount() {
    const { body } = browserUtil.getDocument();
    // @ts-expect-error - Automatic, Please fix when editing this file
    body.classList.remove(styles.disableBody);
  }

  addKeyEventListener = () => {
    browserUtil.getWindow().addEventListener('keyup', this.handleKeyEvent);
  };

  // @ts-expect-error - Automatic, Please fix when editing this file
  handleKeyEvent = (event) => {
    const { dispatch, id } = this.props;

    const ESC = 27;

    // If escape key is pressed then hide modal
    if (event.keyCode === ESC) {
      dispatch(ModalActions.closeModal(id));
    }
  };

  removeKeyEventListener = () => {
    browserUtil.getWindow().removeEventListener('keyup', this.handleKeyEvent);
  };

  hide = () => {
    const { dispatch, id } = this.props;

    dispatch(ModalActions.closeModal(id));
  };

  // @ts-expect-error - Automatic, Please fix when editing this file
  setHideOnMouseUp = ({ target }) => {
    target.addEventListener('click', this.hide, { once: true });
  };

  // @ts-expect-error - Automatic, Please fix when editing this file
  render() {
    const { bodyElementId, children, displayCloseCross, footer, header, theme, variant, visible } = this.props;

    // @ts-expect-error - Automatic, Please fix when editing this file
    const closeClassName = classNames(styles.close, { [styles.closeDarkGrey]: header });
    // @ts-expect-error - Automatic, Please fix when editing this file
    const contentClassName = classNames(styles.content, { [styles[theme]]: theme });

    return (
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string[] | null' is not assignable to type 'string | undefined'.
      <div className={variants.getStyle(variant, styles)}>
        <Animate name="overlayFade">{visible && <div className={styles.overlay} onClick={this.hide} />}</Animate>
        <Animate name="modalSlideIn">
          {visible && (
            <div className={styles.wrapper} onMouseDown={this.setHideOnMouseUp}>
              <div className={styles.modal} onClick={stopEventPropagation} onMouseDown={stopEventPropagation}>
                <div className={contentClassName}>
                  {displayCloseCross && (
                    <a className={closeClassName} onClick={this.hide}>
                      ×
                    </a>
                  )}
                  {header && <header className={styles.header}>{header}</header>}
                  <div className={styles.body} id={bodyElementId}>
                    {children}
                  </div>
                  {footer && <footer className={styles.footer}>{footer}</footer>}
                </div>
              </div>
            </div>
          )}
        </Animate>
      </div>
    );
  }
}

// @ts-expect-error - Automatic, Please fix when editing this file
Modal.defaultProps = {
  afterClose: noop,
  afterOpen: noop,
  beforeClose: noop,
  beforeOpen: noop,
  bodyElementId: undefined,
  children: undefined,
  displayCloseCross: false,
  footer: undefined,
  header: undefined,
  theme: undefined,
  variant: undefined,
};

// @ts-expect-error - Automatic, Please fix when editing this file
const mapStateToProps = (state, ownProps) => ({
  visible: state.modal.visible === ownProps.id,
});

// @ts-expect-error - Automatic, Please fix when editing this file
export default connect(mapStateToProps)(Modal);

export { Modal as ModalForTest, mapStateToProps, MODAL_ID };
